import React from 'react';
import PropTypes from 'prop-types';
import Header from '../UI/Header';
import InlineHeader from '../UI/HeaderInline';
import TranslatedContent from '../Translations/TranslatedContent';

const PatientFormHeader = ({
  isInlineEdit,
  isIntuitiveFlow,
  onClear,
  onSearch,
  isClearEnabled,
  formHeaderTitleTranslation,
  isRxTakenForScan
}) =>
  isInlineEdit ? (
    <InlineHeader
      clearHandler={onClear}
      searchHandler={onSearch}
      isDirty={isClearEnabled}
      isIntuitiveFlow={isIntuitiveFlow}
      isRxTakenForScan={isRxTakenForScan}
    />
  ) : (
    <Header title={<TranslatedContent contentArray={[formHeaderTitleTranslation]} />} />
  );

PatientFormHeader.propTypes = {
  isInlineEdit: PropTypes.bool,
  isIntuitiveFlow: PropTypes.bool,
  onClear: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  isClearEnabled: PropTypes.bool.isRequired,
  formHeaderTitleTranslation: PropTypes.object,
  isRxTakenForScan: PropTypes.bool
};

export default PatientFormHeader;
